import type { MiniSet } from './types'

export const MINI_A2_3: MiniSet[] = [
  // a2-l053 — порядковые -ıncı и распределительные -er
  {
    rule: 'ordinals-distributive',
    explain:
      'Порядковое число - это обычное число плюс -ıncı / -inci / -uncu / -üncü: üç - üçüncü "третий", после гласной - только -ncı: iki - ikinci. А "по два, по три" - другое окончание, -er / -ar (после гласной -şer / -şar): ikişer, üçer.',
    examples: [
      {
        parts: [
          { text: 'üç', label: '', why: '' },
          { text: 'üncü', label: 'порядковое', why: 'последняя гласная ü, поэтому -üncü' },
          { text: ' sınıf', label: '', why: '' },
        ],
        ru: 'третий класс',
      },
      {
        parts: [
          { text: 'Herkese ', label: '', why: '' },
          { text: 'iki', label: '', why: '' },
          { text: 'şer', label: '"по ..."', why: 'после гласной - ş: -şer' },
          { text: ' kitap verdim.', label: '', why: '' },
        ],
        ru: 'Я дал всем по две книги.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'beş',
        baseRu: 'пять',
        task: 'пятый',
        context: { tr: '___ sınıftayım.', ru: 'Я в пятом классе.' },
        slots: [
          { answer: 'beş', options: [], label: '', why: '' },
          { answer: 'inci', options: ['inci', 'ıncı', 'üncü'], label: 'порядковое', why: 'последняя гласная e, поэтому -inci' },
        ],
        answer: 'beşinci',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'altı',
        baseRu: 'шесть',
        task: 'шестой',
        context: { tr: 'Kızım ___ sınıfta.', ru: 'Моя дочь в шестом классе.' },
        slots: [
          { answer: 'altı', options: [], label: '', why: '' },
          { answer: 'ncı', options: ['ncı', 'ıncı', 'nci'], label: 'порядковое', why: 'после гласной - только -ncı; последняя гласная ı' },
        ],
        answer: 'altıncı',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'on',
        baseRu: 'десять',
        task: 'десятый',
        context: { tr: 'Bu benim ___ sınavım.', ru: 'Это мой десятый экзамен.' },
        slots: [
          { answer: 'on', options: [], label: '', why: '' },
          { answer: 'uncu', options: ['uncu', 'ıncı', 'üncü'], label: 'порядковое', why: 'последняя гласная o, поэтому -uncu' },
        ],
        answer: 'onuncu',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'dör',
        baseRu: 'четыре (dört)',
        task: 'четвёртый',
        context: { tr: 'Oğlum ___ sınıfta.', ru: 'Мой сын в четвёртом классе.' },
        slots: [
          { answer: 'dör', options: [], label: '', why: '' },
          { answer: 'd', options: ['d', 't'], label: 'смягчение', why: 'dört: t между гласными становится d' },
          { answer: 'üncü', options: ['üncü', 'uncu', 'inci'], label: 'порядковое', why: 'последняя гласная ö, поэтому -üncü' },
        ],
        answer: 'dördüncü',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'iki',
        baseRu: 'два',
        task: 'по два',
        context: { tr: 'Herkese ___ kitap verdim.', ru: 'Я дал всем по две книги.' },
        slots: [
          { answer: 'iki', options: [], label: '', why: '' },
          { answer: 'şer', options: ['şer', 'er', 'nci'], label: '"по ..."', why: 'после гласной - ş: -şer; -nci было бы "второй"' },
        ],
        answer: 'ikişer',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'üç',
        baseRu: 'три',
        task: 'по три',
        context: { tr: 'Her ders için ___ kitap okuyoruz.', ru: 'По каждому предмету мы читаем по три книги.' },
        slots: [
          { answer: 'üç', options: [], label: '', why: '' },
          { answer: 'er', options: ['er', 'şer', 'üncü'], label: '"по ..."', why: 'после согласной - просто -er; гласных всего две, e и a' },
        ],
        answer: 'üçer',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'on',
        baseRu: 'десять',
        task: 'по десять',
        context: { tr: 'Çocuklara ___ lira verdik.', ru: 'Мы дали детям по десять лир.' },
        slots: [
          { answer: 'on', options: [], label: '', why: '' },
          { answer: 'ar', options: ['ar', 'er', 'uncu'], label: '"по ..."', why: 'последняя гласная o, поэтому -ar; -uncu было бы "десятый"' },
        ],
        answer: 'onar',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Kızım birinci sınıfta.',
        sourceRu: 'Моя дочь в первом классе.',
        instruction: 'Скажите, что дочь во втором классе',
        answer: 'Kızım ikinci sınıfta.',
        variants: [],
        breakdown: [
          { text: 'iki', label: '', why: '' },
          { text: 'nci', label: 'порядковое', why: 'после гласной - только -nci' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Мы работали по четыре часа.',
        instruction: 'Скажите это по-турецки',
        answer: 'Dörder saat çalıştık.',
        variants: [],
        breakdown: [
          { text: 'dörd', label: '', why: '' },
          { text: 'er', label: '"по ..."', why: 'dört: t - d; последняя гласная ö, поэтому -er' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Ты на каком курсе?',
        instruction: 'Скажите это по-турецки',
        answer: 'Kaçıncı sınıftasın?',
        variants: ['Sen kaçıncı sınıftasın?'],
        breakdown: [
          { text: 'Kaç', label: '', why: '' },
          { text: 'ıncı', label: 'который по счёту?', why: 'в университете sınıf - это курс; kaç - kaçıncı' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Сегодня мой третий день!',
        instruction: 'Скажите это по-турецки',
        answer: 'Bugün üçüncü günüm!',
        variants: [],
        breakdown: [
          { text: 'üç', label: '', why: '' },
          { text: 'üncü', label: 'порядковое', why: 'не меняется: падеж и "мой" получает только существительное' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l055 — olmak «стать»
  {
    rule: 'light-verb-olmak-state',
    explain:
      'olmak - "быть" и "становиться". В прошедшем oldu почти всегда значит "стал": Ali doktor oldu - "Али стал врачом". Кем или каким стал - просто слово перед oldu, без всякого падежа. А Ne oldu? - "Что случилось?", дословно "что стало?".',
    examples: [
      {
        parts: [
          { text: 'Ali doktor ', label: '', why: '' },
          { text: 'oldu', label: 'стал', why: 'кем стал - просто слово перед oldu, без падежа' },
          { text: '.', label: '', why: '' },
        ],
        ru: 'Али стал врачом.',
      },
      {
        parts: [
          { text: 'Ne ', label: '', why: '' },
          { text: 'oldu', label: 'что стало?', why: 'самый частый вопрос: "Что случилось?"' },
          { text: '?', label: '', why: '' },
        ],
        ru: 'Что случилось?',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'ol',
        baseRu: 'стать (olmak)',
        task: 'я стал',
        context: { tr: 'Öğretmen ___.', ru: 'Я стал учителем.' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'dum', options: ['dum', 'dun', 'du'], label: 'я, прошедшее (-di)', why: 'последняя гласная o, поэтому -du; "я" даёт -m' },
        ],
        answer: 'oldum',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'ol',
        baseRu: 'стать (olmak)',
        task: 'мы стали',
        context: { tr: 'Biz de abone ___.', ru: 'Мы тоже подписались.' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'duk', options: ['duk', 'dum', 'dunuz'], label: 'мы, прошедшее (-di)', why: '"мы" даёт -k' },
        ],
        answer: 'olduk',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'ol',
        baseRu: 'стать (olmak)',
        task: 'вы стали',
        context: { tr: 'Mezun ___ mu?', ru: 'Вы окончили учёбу?' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'dunuz', options: ['dunuz', 'dun', 'duk'], label: 'вы, прошедшее (-di)', why: 'mezun olmak - "стать выпускником"; "вы" даёт -nuz' },
        ],
        answer: 'oldunuz',
        d: 1,
      },
      {
        kind: 'transform',
        source: 'Babam doktordu.',
        sourceRu: 'Папа был врачом.',
        instruction: 'Скажите, что папа стал врачом (была перемена)',
        answer: 'Babam doktor oldu.',
        variants: [],
        breakdown: [{ text: 'oldu', label: 'стал', why: '-ydı - состояние в прошлом, oldu - перемена; кем стал - без падежа' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Dün hastaydım.',
        sourceRu: 'Вчера я был болен.',
        instruction: 'Скажите "вчера я заболел" - стал больным',
        answer: 'Dün hasta oldum.',
        variants: [],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'dum', label: 'я стал', why: 'перемена - oldum; "был" - hastaydım' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Annem emekliydi.',
        sourceRu: 'Мама была на пенсии.',
        instruction: 'Скажите "мама вышла на пенсию" - стала пенсионеркой',
        answer: 'Annem emekli oldu.',
        variants: [],
        breakdown: [{ text: 'oldu', label: 'стала', why: 'emekli olmak - буквально "стать пенсионером"' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Что случилось?',
        instruction: 'Скажите это по-турецки',
        answer: 'Ne oldu?',
        variants: [],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'du', label: 'прошедшее (-di)', why: 'дословно "что стало?"' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Уже десять часов.',
        instruction: 'Скажите это по-турецки',
        answer: 'Saat on oldu.',
        variants: [],
        breakdown: [{ text: 'oldu', label: 'набралось, наступило', why: 'с числами и временем oldu значит "уже"' }],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Кем ты хочешь стать?',
        instruction: 'Скажите это по-турецки',
        answer: 'Ne olmak istiyorsun?',
        variants: [],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'mak', label: 'стать (-mak istiyorum)', why: '"кем" - просто ne, без падежа' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l058 — взаимное -(ı)ş
  {
    rule: 'reciprocal-barismak',
    explain:
      'Кусочек -ış / -iş / -uş / -üş (после гласной - просто -ş) значит "друг с другом": görmek - видеть, görüşmek - видеться; bulmak - найти, buluşmak - встретиться. Второй человек стоит с -le: Ali\'yle barıştım.',
    examples: [
      {
        parts: [
          { text: 'gör', label: '', why: '' },
          { text: 'üş', label: 'друг с другом', why: 'görmek "видеть", görüşmek "видеться"' },
          { text: 'mek', label: '', why: '' },
        ],
        ru: 'видеться, общаться',
      },
      {
        parts: [
          { text: 'Kardeşim', label: '', why: '' },
          { text: 'le', label: 'с кем (-le)', why: 'barışmak - "друг с другом", второй человек с -le' },
          { text: ' barıştım.', label: '', why: '' },
        ],
        ru: 'Я помирился с братом.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'Ali',
        baseRu: 'Али',
        task: 'с кем?',
        context: { tr: 'Dün ___ barıştım.', ru: 'Вчера я помирился с Али.' },
        slots: [
          { answer: 'Ali', options: [], label: '', why: '' },
          { answer: "'yle", options: ["'yle", "'yi", "'ye"], label: 'с кем (-le)', why: 'barışmak - "друг с другом", второй человек с -le' },
        ],
        answer: "Ali'yle",
        d: 1,
      },
      {
        kind: 'affix',
        base: 'Ayşe',
        baseRu: 'Айше',
        task: 'с кем?',
        context: { tr: 'Akşam ___ buluşuyoruz.', ru: 'Вечером мы встречаемся с Айше.' },
        slots: [
          { answer: 'Ayşe', options: [], label: '', why: '' },
          { answer: "'yle", options: ["'yle", "'yi", "'de"], label: 'с кем (-le)', why: 'buluşmak - "найти друг друга", всегда "с кем"' },
        ],
        answer: "Ayşe'yle",
        d: 1,
      },
      {
        kind: 'affix',
        base: 'o',
        baseRu: 'он, она',
        task: 'с ним',
        context: { tr: 'Üniversitede ___ tanıştım.', ru: 'Я познакомился с ним в университете.' },
        slots: [
          { answer: 'o', options: [], label: '', why: '' },
          { answer: 'nunla', options: ['nunla', 'nu', 'na'], label: 'с кем (-le)', why: 'tanışmak - "друг с другом": onunla, а не onu' },
        ],
        answer: 'onunla',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'Ali',
        baseRu: 'Али',
        task: 'кого?',
        context: { tr: 'Dün ___ gördüm.', ru: 'Вчера я увидел Али.' },
        slots: [
          { answer: 'Ali', options: [], label: '', why: '' },
          { answer: "'yi", options: ["'yi", "'yle", "'de"], label: 'кого? (винительный падеж)', why: 'görmek - один видит другого: винительный; "друг с другом" было бы görüşmek' },
        ],
        answer: "Ali'yi",
        d: 2,
      },
      {
        kind: 'transform',
        source: "Ali'yi buluştum.",
        instruction: 'Исправьте ошибку: buluşmak - "друг с другом"',
        answer: "Ali'yle buluştum.",
        variants: ['Ali ile buluştum.'],
        breakdown: [
          { text: 'Ali', label: '', why: '' },
          { text: "'yle", label: 'с кем (-le)', why: 'buluşmak, tanışmak, barışmak - всегда "с кем", не винительный' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Kardeşimi barıştım.',
        instruction: 'Исправьте ошибку: barışmak - "друг с другом"',
        answer: 'Kardeşimle barıştım.',
        variants: ['Kardeşim ile barıştım.'],
        breakdown: [
          { text: 'Kardeşim', label: '', why: '' },
          { text: 'le', label: 'с кем (-le)', why: 'второй человек - участник, а не предмет: -le' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Мы помирились.',
        instruction: 'Скажите это по-турецки',
        answer: 'Barıştık.',
        variants: ['Biz barıştık.'],
        breakdown: [
          { text: 'barış', label: '', why: '' },
          { text: 'tık', label: 'мы, прошедшее', why: 'без "с кем" такой глагол часто стоит во множественном; после глухой ş - t' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Как вы познакомились?',
        instruction: 'Скажите это по-турецки',
        answer: 'Nasıl tanıştınız?',
        variants: [],
        breakdown: [
          { text: 'tanı', label: '', why: '' },
          { text: 'ş', label: 'друг с другом', why: 'после гласной - просто -ş' },
          { text: 'tınız', label: 'вы, прошедшее', why: '' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Они до сих пор не общаются.',
        instruction: 'Скажите это по-турецки',
        answer: 'Hâlâ görüşmüyorlar.',
        variants: ['Hala görüşmüyorlar.'],
        breakdown: [
          { text: 'gör', label: '', why: '' },
          { text: 'üş', label: 'друг с другом', why: 'görüşmek - видеться и общаться' },
          { text: 'müyorlar', label: 'не, -yor, они', why: '' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l061 — инфинитив-подлежащее
  {
    rule: 'infinitive-subject',
    explain:
      'Инфинитив сам становится подлежащим - как в русском "Курить вредно": Türkçe öğrenmek zor değil. Сначала действие целиком, с -mek на конце, а в самом конце фразы - оценка: zor, önemli, mümkün, yasak, güzel.',
    examples: [
      {
        parts: [
          { text: 'Türkçe öğren', label: '', why: '' },
          { text: 'mek', label: 'инфинитив-подлежащее', why: 'сначала действие с -mek' },
          { text: ' zor değil.', label: '', why: '' },
        ],
        ru: 'Учить турецкий не трудно.',
      },
      {
        parts: [
          { text: 'Burada fotoğraf çekmek ', label: '', why: '' },
          { text: 'yasak', label: 'оценка', why: 'сказуемое всегда последнее' },
          { text: '.', label: '', why: '' },
        ],
        ru: 'Здесь фотографировать запрещено.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'öğren',
        baseRu: 'учить',
        task: 'учить (подлежащее)',
        context: { tr: 'Türkçe ___ zor değil.', ru: 'Учить турецкий не трудно.' },
        slots: [
          { answer: 'öğren', options: [], label: '', why: '' },
          { answer: 'mek', options: ['mek', 'mak', 'iyorum'], label: 'инфинитив (-mek)', why: 'действие-подлежащее - с -mek; последняя гласная e' },
        ],
        answer: 'öğrenmek',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'çek',
        baseRu: 'снимать (fotoğraf çekmek)',
        task: 'фотографировать (подлежащее)',
        context: { tr: 'Burada fotoğraf ___ yasak.', ru: 'Здесь фотографировать запрещено.' },
        slots: [
          { answer: 'çek', options: [], label: '', why: '' },
          { answer: 'mek', options: ['mek', 'mak', 'tim'], label: 'инфинитив (-mek)', why: 'действие целиком, оценка yasak - в конце' },
        ],
        answer: 'çekmek',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yap',
        baseRu: 'делать',
        task: 'заниматься (подлежащее)',
        context: { tr: 'Her gün spor ___ önemli.', ru: 'Заниматься спортом каждый день важно.' },
        slots: [
          { answer: 'yap', options: [], label: '', why: '' },
          { answer: 'mak', options: ['mak', 'mek', 'ıyorum'], label: 'инфинитив (-mak)', why: 'последняя гласная a, поэтому -mak' },
        ],
        answer: 'yapmak',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'gel',
        baseRu: 'приходить',
        task: 'не приходить (подлежащее)',
        context: { tr: 'Geç ___ önemli.', ru: 'Важно не приходить поздно.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'me', options: ['me', 'ma', 'mi'], label: 'не (отрицание)', why: '"не делать" - отрицание внутри самого глагола' },
          { answer: 'mek', options: ['mek', 'mak'], label: 'инфинитив (-mek)', why: '' },
        ],
        answer: 'gelmemek',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Ev bulmak zor.',
        sourceRu: 'Найти жильё трудно.',
        instruction: 'Скажите в прошлом: "было трудно" (-ydı)',
        answer: 'Ev bulmak zordu.',
        variants: [],
        breakdown: [
          { text: 'zor', label: '', why: '' },
          { text: 'du', label: 'было (-ydı)', why: 'меняется оценка, инфинитив - нет' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Burada fotoğraf çekmek yasak.',
        sourceRu: 'Здесь фотографировать запрещено.',
        instruction: 'Задайте вопрос: "Здесь запрещено фотографировать?"',
        answer: 'Burada fotoğraf çekmek yasak mı?',
        variants: [],
        breakdown: [{ text: 'mı', label: 'вопрос', why: 'mi - после оценки, в самом конце; последняя гласная a, поэтому mı' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Жить здесь хорошо.',
        instruction: 'Скажите это по-турецки',
        answer: 'Burada yaşamak güzel.',
        variants: [],
        breakdown: [
          { text: 'yaşa', label: '', why: '' },
          { text: 'mak', label: 'инфинитив-подлежащее', why: 'сначала действие с -mak, оценка - в конце' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Врать плохо.',
        instruction: 'Скажите это по-турецки',
        answer: 'Yalan söylemek kötü.',
        variants: [],
        breakdown: [
          { text: 'söyle', label: '', why: '' },
          { text: 'mek', label: 'инфинитив-подлежащее', why: 'оценка kötü - последняя, без "bu"' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Найти жильё не трудно.',
        instruction: 'Скажите это по-турецки',
        answer: 'Ev bulmak zor değil.',
        variants: [],
        breakdown: [
          { text: 'bul', label: '', why: '' },
          { text: 'mak', label: 'инфинитив-подлежащее', why: 'отрицание - değil после оценки' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l065 — değil mi? и переспрос
  {
    rule: 'tag-question-degil-mi',
    explain:
      'Değil mi? - это русское "да?", "правда?", "ведь": ставите его в конец любой фразы, и она превращается в просьбу подтвердить. Хвостик не меняется ни по лицам, ни по временам. А если хотите переспросить одно слово, повторите его с mı: Yarın mı? - "Завтра?"',
    examples: [
      {
        parts: [
          { text: 'Güzel, ', label: '', why: '' },
          { text: 'değil mi', label: 'хвостик "правда?"', why: 'одно на все лица и времена' },
          { text: '?', label: '', why: '' },
        ],
        ru: 'Красиво, правда?',
      },
      {
        parts: [
          { text: 'Yarın', label: '', why: '' },
          { text: ' mı', label: 'переспрос', why: 'слово + mı / mi / mu / mü по гармонии' },
          { text: '?', label: '', why: '' },
        ],
        ru: 'Завтра?',
      },
    ],
    items: [
      {
        kind: 'transform',
        source: 'Güzel.',
        sourceRu: 'Красиво.',
        instruction: 'Попросите подтвердить: "Красиво, правда?"',
        answer: 'Güzel, değil mi?',
        variants: ['Güzel değil mi?'],
        breakdown: [{ text: 'değil mi', label: 'хвостик "правда?"', why: 'в конец любой фразы; не "evet?"' }],
        d: 1,
      },
      {
        kind: 'transform',
        source: 'Toplantı yarın.',
        sourceRu: 'Собрание завтра.',
        instruction: 'Переспросите одно слово: "Завтра?"',
        answer: 'Yarın mı?',
        variants: [],
        breakdown: [
          { text: 'Yarın', label: '', why: '' },
          { text: ' mı', label: 'переспрос', why: 'последняя гласная ı, поэтому mı' },
        ],
        d: 1,
      },
      {
        kind: 'transform',
        source: 'Ali evlendi.',
        sourceRu: 'Али женился.',
        instruction: 'Переспросите: "Именно Али?"',
        answer: 'Ali mi?',
        variants: [],
        breakdown: [
          { text: 'Ali', label: '', why: '' },
          { text: ' mi', label: 'переспрос', why: 'последняя гласная i, поэтому mi' },
        ],
        d: 1,
      },
      {
        kind: 'transform',
        source: 'Bu ceket bin lira.',
        sourceRu: 'Эта куртка стоит тысячу лир.',
        instruction: 'Переспросите: "Тысяча лир?"',
        answer: 'Bin lira mı?',
        variants: [],
        breakdown: [
          { text: 'lira', label: '', why: '' },
          { text: ' mı', label: 'переспрос', why: 'последняя гласная a, поэтому mı' },
        ],
        d: 1,
      },
      {
        kind: 'transform',
        source: "Sen Ayşe'sin.",
        sourceRu: 'Ты Айше.',
        instruction: 'Попросите подтвердить: "Ты ведь Айше, да?"',
        answer: "Sen Ayşe'sin, değil mi?",
        variants: ["Sen Ayşe'sin değil mi?", "Ayşe'sin, değil mi?"],
        breakdown: [{ text: 'değil mi', label: 'хвостик "да?"', why: 'по лицам не меняется: не "değil misin"' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Gelmedin.',
        sourceRu: 'Ты не пришёл.',
        instruction: 'Попросите подтвердить: "Ты ведь не пришёл, да?"',
        answer: 'Gelmedin, değil mi?',
        variants: ['Gelmedin değil mi?'],
        breakdown: [{ text: 'değil mi', label: 'хвостик "да?"', why: 'годится и после отрицания; mi в самой фразе не нужен' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Ali geldi.',
        sourceRu: 'Али пришёл.',
        instruction: 'Спросите, пришёл ли именно Али',
        answer: 'Ali mi geldi?',
        variants: [],
        breakdown: [
          { text: 'Ali', label: '', why: '' },
          { text: ' mi', label: 'вопрос к слову', why: 'mi - сразу после слова, о котором спрашиваем; Ali geldi mi? - "Али пришёл?"' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Ты ведь завтра придёшь?',
        instruction: 'Скажите это по-турецки',
        answer: 'Yarın geleceksin, değil mi?',
        variants: ['Yarın geleceksin değil mi?', 'Yarın geliyorsun, değil mi?', 'Yarın geliyorsun değil mi?'],
        breakdown: [{ text: 'değil mi', label: 'хвостик "ведь"', why: 'фраза остаётся утвердительной, вопрос - только в хвостике' }],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Ты ведь знаешь турецкий, да?',
        instruction: 'Скажите это по-турецки',
        answer: 'Türkçe biliyorsun, değil mi?',
        variants: ['Türkçe biliyorsun değil mi?', 'Türkçe bilirsin, değil mi?', 'Türkçe bilirsin değil mi?', 'Sen Türkçe biliyorsun, değil mi?'],
        breakdown: [{ text: 'değil mi', label: 'хвостик "да?"', why: 'не "biliyor musun, değil mi" - mi только в хвостике' }],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l066 — шкала уверенности + широкое время
  {
    rule: 'epistemic-certainty-scale',
    explain:
      'Когда вы не уверены, берут слово-оценку и широкое время: Gelir herhalde - "наверное, придёт", Galiba bilir - "кажется, знает", Kesin gelir - "точно придёт". Шкала: kesin - "точно", herhalde, galiba, sanırım - "наверное, кажется", belki - "может быть", hiç sanmıyorum - "вряд ли".',
    examples: [
      {
        parts: [
          { text: 'Gel', label: '', why: '' },
          { text: 'ir', label: 'широкое (-ir)', why: '-ir звучит как "так я думаю" - догадка ложится в него' },
          { text: ' herhalde', label: 'наверное', why: 'часто уходит в конец фразы' },
          { text: '.', label: '', why: '' },
        ],
        ru: 'Наверное, придёт.',
      },
      {
        parts: [
          { text: 'Kesin', label: 'точно', why: 'самая уверенная ступень шкалы' },
          { text: ' gel', label: '', why: '' },
          { text: 'ir', label: 'широкое (-ir)', why: '' },
          { text: '.', label: '', why: '' },
        ],
        ru: 'Точно придёт.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'gel',
        baseRu: 'приходить',
        task: 'догадка: придёт',
        context: { tr: 'Ali hiç geç kalmaz, kesin ___.', ru: 'Али никогда не опаздывает, точно придёт.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'ir', options: ['ir', 'er', 'di'], label: 'широкое (-ir)', why: 'gelmek - из 13 глаголов на -ir; догадка - в широком' },
        ],
        answer: 'gelir',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'bil',
        baseRu: 'знать',
        task: 'догадка: знает',
        context: { tr: 'Ayşe Türkçe ___ galiba.', ru: 'Айше, кажется, знает турецкий.' },
        slots: [
          { answer: 'bil', options: [], label: '', why: '' },
          { answer: 'ir', options: ['ir', 'er', 'di'], label: 'широкое (-ir)', why: 'bilmek - из 13 глаголов на -ir' },
        ],
        answer: 'bilir',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'kal',
        baseRu: 'оставаться (geç kalmak - опоздать)',
        task: 'догадка: опоздает',
        context: { tr: 'Otobüs geç ___ sanırım.', ru: 'Думаю, автобус опоздает.' },
        slots: [
          { answer: 'kal', options: [], label: '', why: '' },
          { answer: 'ır', options: ['ır', 'ar', 'dı'], label: 'широкое (-ır)', why: 'kalmak - из 13 глаголов на -ir: kalır' },
        ],
        answer: 'kalır',
        d: 1,
      },
      {
        kind: 'transform',
        source: 'Ali yarın gelecek.',
        sourceRu: 'Али приедет завтра (я знаю).',
        instruction: 'Скажите как догадку: "Али, наверное, приедет завтра"',
        answer: 'Ali yarın gelir herhalde.',
        variants: ['Ali yarın herhalde gelir.', 'Herhalde Ali yarın gelir.'],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'ir', label: 'широкое (-ir)', why: '-ecek - знаю, решено; -ir + herhalde - так я думаю' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Emre bu işi sevmiyor.',
        sourceRu: 'Эмре не нравится эта работа.',
        instruction: 'Скажите как догадку: "Эмре, наверное, не любит такую работу"',
        answer: 'Emre bu işi sevmez herhalde.',
        variants: ['Emre herhalde bu işi sevmez.', 'Herhalde Emre bu işi sevmez.'],
        breakdown: [
          { text: 'sev', label: '', why: '' },
          { text: 'mez', label: 'широкое, отрицание', why: 'догадка с "не" - -mez' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Наверное, придёт.',
        instruction: 'Скажите это по-турецки',
        answer: 'Gelir herhalde.',
        variants: ['Herhalde gelir.', 'Galiba gelir.', 'Gelir galiba.'],
        breakdown: [{ text: 'herhalde', label: 'наверное', why: '"наверное" - herhalde или galiba, а не belki: belki - "может быть", 50 на 50' }],
        blankWhole: true,
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Вряд ли.',
        instruction: 'Скажите это по-турецки',
        answer: 'Hiç sanmıyorum.',
        variants: ['Sanmıyorum.'],
        breakdown: [{ text: 'Hiç sanmıyorum', label: 'вряд ли', why: 'буквально "совсем не думаю"' }],
        blankWhole: true,
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Тучи совсем чёрные, кажется, будет дождь.',
        instruction: 'Скажите это по-турецки',
        answer: 'Bulutlar çok siyah, galiba yağmur yağacak.',
        variants: ['Bulutlar çok siyah, galiba yağmur yağar.', 'Bulutlar çok siyah, yağmur yağacak galiba.'],
        breakdown: [{ text: 'galiba', label: 'кажется', why: 'galiba - догадка по признакам: вижу чёрные тучи' }],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Он точно придёт.',
        instruction: 'Скажите это по-турецки',
        answer: 'Kesin gelir.',
        variants: ['O kesin gelir.', 'Kesinlikle gelir.', 'O kesinlikle gelir.', 'Kesin gelecek.', 'O kesin gelecek.'],
        breakdown: [
          { text: 'Kesin ', label: 'точно', why: 'в разговоре - "наверняка"' },
          { text: 'gel', label: '', why: '' },
          { text: 'ir', label: 'широкое (-ir)', why: '' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Одиннадцать часов, наверное, спит.',
        instruction: 'Скажите это по-турецки',
        answer: 'Saat on bir, herhalde uyuyor.',
        variants: ['Saat on bir, uyuyor herhalde.', 'Saat on bir, galiba uyuyor.'],
        breakdown: [{ text: 'herhalde', label: 'наверное', why: 'herhalde - вывод по логике' }],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l069 — повтор блока 41–68
  {
    rule: 'review-a2-block4',
    explain:
      'Блок 41-68 учил рассказывать (что было, что смогли, чего не смогли, что решили) и сравнивать (-den daha, kadar, gibi, en). Ещё в нём был падеж после глагола. Если сомневаетесь, спросите себя, о каком времени речь и какой падеж просит глагол.',
    examples: [
      {
        parts: [
          { text: 'Toplantıya ', label: '', why: '' },
          { text: 'gel', label: '', why: '' },
          { text: 'eme', label: 'не смог', why: 'gelmedim - "не пришёл", gelemedim - "не смог прийти"' },
          { text: 'dim', label: 'я, прошедшее', why: '' },
          { text: '.', label: '', why: '' },
        ],
        ru: 'Я не смог прийти на совещание.',
      },
      {
        parts: [
          { text: 'Proje', label: '', why: '' },
          { text: 'den', label: 'о чём? (-den)', why: 'bahsetmek просит -den, а не -de' },
          { text: ' bahsetti.', label: '', why: '' },
        ],
        ru: 'Он рассказал о проекте.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'proje',
        baseRu: 'проект',
        task: 'о чём? (bahsetmek)',
        context: { tr: 'Toplantıda ___ bahsetti.', ru: 'На совещании он рассказал о проекте.' },
        slots: [
          { answer: 'proje', options: [], label: '', why: '' },
          { answer: 'den', options: ['den', 'de', 'yi'], label: 'о чём? (-den)', why: 'bahsetmek просит -den; projede - "в проекте"' },
        ],
        answer: 'projeden',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'ben',
        baseRu: 'я',
        task: 'чем я (сравнение)',
        context: { tr: 'Ali ___ daha deneyimli.', ru: 'Али опытнее меня.' },
        slots: [
          { answer: 'ben', options: [], label: '', why: '' },
          { answer: 'den', options: ['den', 'im', 'e'], label: 'чем? (-den)', why: 'второй предмет сравнения получает -den' },
        ],
        answer: 'benden',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'sen',
        baseRu: 'ты',
        task: 'такой же, как ты',
        context: { tr: 'Ali ___ kadar deneyimli.', ru: 'Али такой же опытный, как ты.' },
        slots: [
          { answer: 'sen', options: [], label: '', why: '' },
          { answer: 'in', options: ['in', 'den', 'e'], label: 'kadar после местоимения', why: 'равенство - kadar, местоимение перед ним в родительном: senin kadar' },
        ],
        answer: 'senin',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'gel',
        baseRu: 'приходить',
        task: 'не смог прийти',
        context: { tr: 'Toplantıya ___.', ru: 'Я не смог прийти на совещание.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'eme', options: ['eme', 'me', 'ebil'], label: 'не смог', why: 'gelmedim - "не пришёл", gelemedim - "не смог прийти"' },
          { answer: 'dim', options: ['dim', 'di'], label: 'я, прошедшее', why: '' },
        ],
        answer: 'gelemedim',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'şef',
        baseRu: 'шеф',
        task: 'перед кем? (özür dilemek)',
        context: { tr: 'Dün ___ özür diledim.', ru: 'Вчера я извинился перед шефом.' },
        slots: [
          { answer: 'şef', options: [], label: '', why: '' },
          { answer: 'ten', options: ['ten', 'e', 'i'], label: 'перед кем? (-den)', why: 'özür dilemek просит -den; после глухой f - -ten' },
        ],
        answer: 'şeften',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'meslektaşım',
        baseRu: 'мой коллега',
        task: 'кого? (affetmek)',
        context: { tr: 'Sonunda ___ affettim.', ru: 'В конце концов я простил коллегу.' },
        slots: [
          { answer: 'meslektaşım', options: [], label: '', why: '' },
          { answer: 'ı', options: ['ı', 'a', 'dan'], label: 'кого? (винительный падеж)', why: 'affetmek просит винительный, как "простить кого"' },
        ],
        answer: 'meslektaşımı',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Yarın erken gelirim.',
        sourceRu: 'Завтра приду пораньше (обещаю).',
        instruction: 'Скажите как решённый план (-ecek)',
        answer: 'Yarın erken geleceğim.',
        variants: [],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'eceğim', label: 'решено (-ecek)', why: '-ir - обещаю на ходу, -ecek - так решено' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Dün işten erken çıktım.',
        sourceRu: 'Вчера я ушёл с работы пораньше.',
        instruction: 'Скажите "мне удалось уйти" (-ebil)',
        answer: 'Dün işten erken çıkabildim.',
        variants: [],
        breakdown: [
          { text: 'çık', label: '', why: '' },
          { text: 'abil', label: 'смог', why: '-ebil в прошедшем - "смог, удалось"' },
          { text: 'dim', label: 'я, прошедшее', why: '' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Сначала я был стажёром, потом стал специалистом.',
        instruction: 'Скажите это по-турецки',
        answer: 'Önce stajyerdim, sonra uzman oldum.',
        variants: [],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'dum', label: 'стал', why: 'состояние - -ydı (stajyerdim), перемена - olmak (oldum)' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Мы ищем секретаря, который знает турецкий.',
        instruction: 'Скажите это по-турецки',
        answer: 'Türkçe bilen bir sekreter arıyoruz.',
        variants: [],
        breakdown: [
          { text: 'bil', label: '', why: '' },
          { text: 'en', label: 'тот, кто (-en)', why: '"который знает" - bilen, перед словом' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Каждый день перерабатывать тяжело.',
        instruction: 'Скажите это по-турецки',
        answer: 'Her gün fazla mesai yapmak zor.',
        variants: [],
        breakdown: [
          { text: 'yap', label: '', why: '' },
          { text: 'mak', label: 'инфинитив-подлежащее', why: 'действие с -mak, оценка zor - в конце' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Шеф, наверное, придёт поздно.',
        instruction: 'Скажите это по-турецки',
        answer: 'Şef herhalde geç gelir.',
        variants: ['Şef geç gelir herhalde.', 'Herhalde şef geç gelir.', 'Şef galiba geç gelir.'],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'ir', label: 'широкое (-ir)', why: 'догадка - herhalde + широкое время' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l071 — превосходная с родительным
  {
    rule: 'superlative-genitive',
    explain:
      'Область, в которой выбираем самого-самого, - в родительном (-ın), дальше en + прилагательное, а само существительное получает "его" (-ı / -sı): dünyanın en büyük gölü - "самое большое озеро в мире", Türkiye\'nin en büyük adası - "самый большой остров Турции".',
    examples: [
      {
        parts: [
          { text: 'dünya', label: '', why: '' },
          { text: 'nın', label: 'где выбираем (родительный падеж)', why: 'после гласной - -nın' },
          { text: ' en büyük ', label: 'самый', why: '' },
          { text: 'göl', label: '', why: '' },
          { text: 'ü', label: '"его" (-ı)', why: 'первое слово в родительном - второе обязано взять "его"' },
        ],
        ru: 'самое большое озеро в мире',
      },
      {
        parts: [
          { text: "Türkiye'nin en büyük ", label: '', why: '' },
          { text: 'ada', label: '', why: '' },
          { text: 'sı', label: '"его" (-sı)', why: 'после гласной - -sı' },
        ],
        ru: 'самый большой остров Турции',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'ada',
        baseRu: 'остров',
        task: 'остров (+ "его")',
        context: { tr: "Türkiye'nin en büyük ___ hangisi?", ru: 'Какой остров самый большой в Турции?' },
        slots: [
          { answer: 'ada', options: [], label: '', why: '' },
          { answer: 'sı', options: ['sı', 'ı', 'yı'], label: '"его" (-sı)', why: 'после родительного второе слово берёт "его"; после гласной - -sı' },
        ],
        answer: 'adası',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'göl',
        baseRu: 'озеро',
        task: 'озеро (+ "его")',
        context: { tr: "Türkiye'nin en büyük ___ Van Gölü.", ru: 'Самое большое озеро Турции - Ван.' },
        slots: [
          { answer: 'göl', options: [], label: '', why: '' },
          { answer: 'ü', options: ['ü', 'u', 'sü'], label: '"его" (-ı)', why: 'после согласной - -ı по гармонии: ö становится ü' },
        ],
        answer: 'gölü',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'şehr',
        baseRu: 'город (şehir)',
        task: 'город (+ "его")',
        context: { tr: "Rize Türkiye'nin en yağmurlu ___.", ru: 'Ризе - самый дождливый город Турции.' },
        slots: [
          { answer: 'şehr', options: [], label: '', why: '' },
          { answer: 'i', options: ['i', 'ı', 'si'], label: '"его" (-i)', why: 'şehir теряет гласную: şehri' },
        ],
        answer: 'şehri',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'dünya',
        baseRu: 'мир',
        task: 'где выбираем? (родительный падеж)',
        context: { tr: 'Bu, ___ en büyük okyanusu.', ru: 'Это самый большой океан в мире.' },
        slots: [
          { answer: 'dünya', options: [], label: '', why: '' },
          { answer: 'nın', options: ['nın', 'ın', 'da'], label: 'где выбираем (родительный падеж)', why: 'область - в родительном, а не "dünyada"; после гласной - -nın' },
        ],
        answer: 'dünyanın',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'sınıf',
        baseRu: 'класс',
        task: 'где выбираем? (родительный падеж)',
        context: { tr: 'Ali ___ en çalışkan öğrencisi.', ru: 'Али - самый старательный ученик в классе.' },
        slots: [
          { answer: 'sınıf', options: [], label: '', why: '' },
          { answer: 'ın', options: ['ın', 'ta', 'nın'], label: 'где выбираем (родительный падеж)', why: 'по-русски "в классе", по-турецки - "класса": sınıfın' },
        ],
        answer: 'sınıfın',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'vadi',
        baseRu: 'долина',
        task: 'долина (+ "его")',
        context: { tr: "Bu, Kapadokya'nın en güzel ___.", ru: 'Это самая красивая долина Каппадокии.' },
        slots: [
          { answer: 'vadi', options: [], label: '', why: '' },
          { answer: 'si', options: ['si', 'i', 'yi'], label: '"его" (-si)', why: 'после гласной - -si' },
        ],
        answer: 'vadisi',
        d: 2,
      },
      {
        kind: 'transform',
        source: "Afrika'nın en büyük çöl.",
        instruction: 'Исправьте ошибку: после родительного второе слово берёт "его"',
        answer: "Afrika'nın en büyük çölü.",
        variants: [],
        breakdown: [
          { text: 'çöl', label: '', why: '' },
          { text: 'ü', label: '"его" (-ı)', why: 'раз первое слово в родительном, второе обязано взять "его"' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: "Türkiye'nin en büyük adası hangisi?",
        sourceRu: 'Какой остров самый большой в Турции?',
        instruction: 'Спросите без области: "Какой остров самый большой?"',
        answer: 'En büyük ada hangisi?',
        variants: [],
        breakdown: [{ text: 'ada', label: 'без "его"', why: 'если области нет - хвостов нет' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Самый большой город Турции - Стамбул.',
        instruction: 'Скажите это по-турецки',
        answer: "Türkiye'nin en büyük şehri İstanbul.",
        variants: [],
        breakdown: [
          { text: 'Türkiye', label: '', why: '' },
          { text: "'nin", label: 'где выбираем (родительный падеж)', why: '' },
          { text: ' en büyük ', label: 'самый', why: '' },
          { text: 'şehr', label: '', why: '' },
          { text: 'i', label: '"его" (-i)', why: 'şehir - şehri' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Он лучший специалист компании.',
        instruction: 'Скажите это по-турецки',
        answer: 'O, şirketin en iyi uzmanı.',
        variants: ['O şirketin en iyi uzmanı.'],
        breakdown: [
          { text: 'şirket', label: '', why: '' },
          { text: 'in', label: 'где выбираем (родительный падеж)', why: '' },
          { text: ' en iyi ', label: 'самый', why: '' },
          { text: 'uzman', label: '', why: '' },
          { text: 'ı', label: '"его" (-ı)', why: 'второе слово с хвостом' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l072 — повтор: -ir о природе, -den daha, en
  {
    rule: 'review-nature',
    explain:
      'Здесь всё знакомое, только на теме природы. Широкое время - для того, что так устроено всегда: Bitkiler güneşi sever. Сравнение с -den - "больше, чем": Güneş Dünya\'dan daha büyük. И en - "самый": Asya en büyük kıta, а с областью - dünyanın en büyük kıtası.',
    examples: [
      {
        parts: [
          { text: 'Bitkiler güneşi ', label: '', why: '' },
          { text: 'sev', label: '', why: '' },
          { text: 'er', label: 'широкое (-er)', why: 'так бывает всегда' },
          { text: '.', label: '', why: '' },
        ],
        ru: 'Растения любят солнце.',
      },
      {
        parts: [
          { text: 'Güneş ', label: '', why: '' },
          { text: 'Dünya', label: '', why: '' },
          { text: "'dan", label: 'чем? (-den)', why: 'то, с чем сравниваем, берёт -den' },
          { text: ' daha büyük.', label: '', why: '' },
        ],
        ru: 'Солнце больше Земли.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'uç',
        baseRu: 'летать',
        task: 'так бывает всегда',
        context: { tr: 'Kuşlar kışın güneye ___.', ru: 'Зимой птицы улетают на юг.' },
        slots: [
          { answer: 'uç', options: [], label: '', why: '' },
          { answer: 'ar', options: ['ar', 'ır', 'ur'], label: 'широкое (-ar)', why: 'односложный глагол - -ar' },
        ],
        answer: 'uçar',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yaşa',
        baseRu: 'жить',
        task: 'никогда так не бывает',
        context: { tr: 'Canlılar susuz ___.', ru: 'Живые существа не живут без воды.' },
        slots: [
          { answer: 'yaşa', options: [], label: '', why: '' },
          { answer: 'maz', options: ['maz', 'mez', 'mam'], label: 'широкое, отрицание', why: 'в третьем лице - -maz без лица; последняя гласная a, поэтому -maz; yaşamam - "я не живу"' },
        ],
        answer: 'yaşamaz',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'Dünya',
        baseRu: 'Земля',
        task: 'чем? (сравнение)',
        context: { tr: 'Güneş ___ daha büyük.', ru: 'Солнце больше Земли.' },
        slots: [
          { answer: 'Dünya', options: [], label: '', why: '' },
          { answer: "'dan", options: ["'dan", "'nın", "'da"], label: 'чем? (-den)', why: 'русское "чем" - только -den, не -nın' },
        ],
        answer: "Dünya'dan",
        d: 1,
      },
      {
        kind: 'affix',
        base: 'kıta',
        baseRu: 'континент',
        task: 'континент (+ "его")',
        context: { tr: 'Asya dünyanın en büyük ___.', ru: 'Азия - самый большой континент в мире.' },
        slots: [
          { answer: 'kıta', options: [], label: '', why: '' },
          { answer: 'sı', options: ['sı', 'ı', 'da'], label: '"его" (-sı)', why: 'с областью (dünyanın) - хвост "его"' },
        ],
        answer: 'kıtası',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Asya büyük.',
        sourceRu: 'Азия большая.',
        instruction: 'Скажите "Азия - самый большой континент" (без области)',
        answer: 'Asya en büyük kıta.',
        variants: [],
        breakdown: [{ text: 'en', label: 'самый', why: 'без области - просто en, без хвостов' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Canlılar büyür.',
        sourceRu: 'Живое растёт.',
        instruction: 'Скажите про скалу: "Скала не растёт"',
        answer: 'Kaya büyümez.',
        variants: ['Kayalar büyümez.'],
        breakdown: [
          { text: 'büyü', label: '', why: '' },
          { text: 'mez', label: 'широкое, отрицание', why: 'никогда так не бывает - -mez' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: "Jüpiter Dünya'dan büyük.",
        sourceRu: 'Юпитер больше Земли.',
        instruction: 'Скажите "гораздо больше"',
        answer: "Jüpiter Dünya'dan çok daha büyük.",
        variants: [],
        breakdown: [{ text: 'çok daha', label: 'гораздо', why: '"гораздо больше" - çok daha' }],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Растения любят солнце.',
        instruction: 'Скажите это по-турецки',
        answer: 'Bitkiler güneşi sever.',
        variants: ['Bitkiler güneşi severler.'],
        breakdown: [
          { text: 'sev', label: '', why: '' },
          { text: 'er', label: 'широкое (-er)', why: 'свойство, так всегда - не -yor' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Юпитер - самая большая планета Солнечной системы.',
        instruction: 'Скажите это по-турецки',
        answer: 'Jüpiter Güneş sisteminin en büyük gezegeni.',
        variants: [],
        breakdown: [
          { text: 'gezegen', label: '', why: '' },
          { text: 'i', label: '"его" (-i)', why: 'с областью в родительном - хвост у второго слова' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Это дерево будет выше меня.',
        instruction: 'Скажите это по-турецки',
        answer: 'Bu ağaç benden daha uzun olacak.',
        variants: ['Bu ağaç benden uzun olacak.'],
        breakdown: [
          { text: 'ben', label: '', why: '' },
          { text: 'den', label: 'чем? (-den)', why: '"выше меня" - benden daha uzun' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l077 — -ki и порядковые
  {
    rule: 'suffix-ki-floors',
    explain:
      'Чтобы сказать "какой" - сосед, квартира, комната на этом этаже, - добавьте знакомый -ki: üçüncü kattaki komşu - "сосед с третьего этажа", üst kattaki komşu - "сосед сверху". Формула: этаж + -da/-ta + -ki, и всё это стоит ПЕРЕД словом.',
    examples: [
      {
        parts: [
          { text: 'üçüncü kat', label: '', why: '' },
          { text: 'ta', label: 'где? (-ta)', why: 'kat кончается на глухую t - -da оглушается' },
          { text: 'ki', label: 'какой? (-ki)', why: '-ki гармонии не подчиняется' },
          { text: ' oda', label: '', why: '' },
        ],
        ru: 'комната на третьем этаже',
      },
      {
        parts: [
          { text: 'üst kat', label: '', why: '' },
          { text: 'ta', label: 'где? (-ta)', why: '' },
          { text: 'ki', label: 'какой? (-ki)', why: 'признак встаёт перед словом' },
          { text: ' komşu', label: '', why: '' },
        ],
        ru: 'сосед сверху',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'koridor',
        baseRu: 'коридор',
        task: 'какой? (тот, что в коридоре)',
        context: { tr: '___ ışığı kapat.', ru: 'Выключи свет в коридоре.' },
        slots: [
          { answer: 'koridor', options: [], label: '', why: '' },
          { answer: 'da', options: ['da', 'ta', 'de'], label: 'где? (-da)', why: 'после звонкой r - d; последняя гласная o, поэтому a' },
          { answer: 'ki', options: ['ki', 'kı'], label: 'какой? (-ki)', why: '-ki гармонии не подчиняется' },
        ],
        answer: 'koridordaki',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'asansör',
        baseRu: 'лифт',
        task: 'какой? (тот, что в лифте)',
        context: { tr: '___ kadın kim?', ru: 'Кто эта женщина в лифте?' },
        slots: [
          { answer: 'asansör', options: [], label: '', why: '' },
          { answer: 'de', options: ['de', 'da', 'te'], label: 'где? (-de)', why: 'последняя гласная ö, поэтому e' },
          { answer: 'ki', options: ['ki', 'kü'], label: 'какой? (-ki)', why: '-ki всегда с i' },
        ],
        answer: 'asansördeki',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'kat',
        baseRu: 'этаж',
        task: 'какой? (тот, что на этаже)',
        context: { tr: 'Üst ___ komşu çok kibar.', ru: 'Сосед сверху очень вежливый.' },
        slots: [
          { answer: 'kat', options: [], label: '', why: '' },
          { answer: 'ta', options: ['ta', 'da'], label: 'где? (-ta)', why: 'после глухой t - ta' },
          { answer: 'ki', options: ['ki', 'kı'], label: 'какой? (-ki)', why: '-ki цепляется к "где?": kattaki' },
        ],
        answer: 'kattaki',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'kat',
        baseRu: 'этаж',
        task: 'где? (на этаже)',
        context: { tr: 'Yönetici zemin ___ oturuyor.', ru: 'Управляющий живёт на нулевом этаже.' },
        slots: [
          { answer: 'kat', options: [], label: '', why: '' },
          { answer: 'ta', options: ['ta', 'taki', 'da'], label: 'где? (-ta)', why: 'здесь ответ на "где?", а не "какой?" - -ki не нужен' },
        ],
        answer: 'katta',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'kat',
        baseRu: 'этаж',
        task: 'те, что на этаже',
        context: { tr: 'Üst ___ çok gürültülü.', ru: 'Соседи сверху очень шумные.' },
        slots: [
          { answer: 'kat', options: [], label: '', why: '' },
          { answer: 'ta', options: ['ta', 'da'], label: 'где? (-ta)', why: '' },
          { answer: 'ki', options: ['ki', 'kı'], label: 'какой? (-ki)', why: '' },
          { answer: 'ler', options: ['ler', 'lar'], label: 'множественное число', why: '-ki вместо слова, с -ler - это люди; после ki - -ler' },
        ],
        answer: 'kattakiler',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Komşu üst katta.',
        sourceRu: 'Сосед - наверху.',
        instruction: 'Сделайте место признаком: "сосед сверху"',
        answer: 'Üst kattaki komşu',
        variants: [],
        breakdown: [
          { text: 'kat', label: '', why: '' },
          { text: 'ta', label: 'где? (-ta)', why: '' },
          { text: 'ki', label: 'какой? (-ki)', why: 'признак - с -ki и ПЕРЕД словом' },
        ],
        d: 2,
      },
      {
        kind: 'transform',
        source: 'Oda çatı katında.',
        sourceRu: 'Комната - на мансарде.',
        instruction: 'Сделайте место признаком: "комната на мансарде"',
        answer: 'Çatı katındaki oda',
        variants: [],
        breakdown: [
          { text: 'katı', label: '', why: '' },
          { text: 'n', label: 'связка n', why: 'у слова с "его" (çatı katı) перед -da встаёт n' },
          { text: 'da', label: 'где? (-da)', why: '' },
          { text: 'ki', label: 'какой? (-ki)', why: 'признак - с -ki и перед словом' },
        ],
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Комната на третьем этаже свободна.',
        instruction: 'Скажите это по-турецки',
        answer: 'Üçüncü kattaki oda boş.',
        variants: [],
        breakdown: [
          { text: 'Üçüncü kat', label: '', why: '' },
          { text: 'ta', label: 'где? (-ta)', why: '' },
          { text: 'ki', label: 'какой? (-ki)', why: 'этаж + -ta + -ki - перед словом oda' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'На каком вы этаже?',
        instruction: 'Скажите это по-турецки',
        answer: 'Kaçıncı kattasınız?',
        variants: ['Siz kaçıncı kattasınız?'],
        breakdown: [
          { text: 'Kaç', label: '', why: '' },
          { text: 'ıncı', label: 'который по счёту?', why: 'этаж спрашивают через kaçıncı' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

  // a2-l078 — -(ı)msı и «по утрам»
  {
    rule: 'suffix-imsi-times',
    explain:
      '-(ı)msı - это русское "-оватый": mavi "синий" - mavimsi "синеватый", sarı - sarımsı "желтоватый". А -ları / -leri на части дня значит "по утрам, по вечерам" - регулярно: sabahları, akşamları, geceleri. Обычно рядом стоит широкое время: Sabahları çay içerim.',
    examples: [
      {
        parts: [
          { text: 'mavi', label: '', why: '' },
          { text: 'msi', label: '"-оватый"', why: 'после гласной -msi просто прилипает' },
        ],
        ru: 'синеватый',
      },
      {
        parts: [
          { text: 'Sabah', label: '', why: '' },
          { text: 'ları', label: '"по ..." (регулярно)', why: 'sabahları - привычка, рядом широкое время' },
          { text: ' çay içerim.', label: '', why: '' },
        ],
        ru: 'По утрам я пью чай.',
      },
    ],
    items: [
      {
        kind: 'affix',
        base: 'mavi',
        baseRu: 'синий',
        task: 'синеватый',
        context: { tr: 'Sabahları deniz ___ olur.', ru: 'По утрам море становится синеватым.' },
        slots: [
          { answer: 'mavi', options: [], label: '', why: '' },
          { answer: 'msi', options: ['msi', 'msı', 'imsi'], label: '"-оватый"', why: 'после гласной - без вставной гласной; последняя гласная i' },
        ],
        answer: 'mavimsi',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'sarı',
        baseRu: 'жёлтый',
        task: 'желтоватый',
        slots: [
          { answer: 'sarı', options: [], label: '', why: '' },
          { answer: 'msı', options: ['msı', 'msi', 'ımsı'], label: '"-оватый"', why: 'последняя гласная ı, поэтому -msı' },
        ],
        answer: 'sarımsı',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'yeşil',
        baseRu: 'зелёный',
        task: 'зеленоватый',
        context: { tr: 'Gözleri ___.', ru: 'Глаза у него зеленоватые.' },
        slots: [
          { answer: 'yeşil', options: [], label: '', why: '' },
          { answer: 'imsi', options: ['imsi', 'msi', 'ımsı'], label: '"-оватый"', why: 'после согласной встаёт гласная: -imsi' },
        ],
        answer: 'yeşilimsi',
        d: 1,
      },
      {
        kind: 'affix',
        base: 'turuncu',
        baseRu: 'оранжевый',
        task: 'оранжеватый',
        context: { tr: 'Akşamları deniz ___ olur.', ru: 'По вечерам море становится оранжеватым.' },
        slots: [
          { answer: 'turuncu', options: [], label: '', why: '' },
          { answer: 'msu', options: ['msu', 'msı', 'msi'], label: '"-оватый"', why: 'гармония на четыре гласные: последняя u, поэтому -msu' },
        ],
        answer: 'turuncumsu',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'sabah',
        baseRu: 'утро',
        task: 'по утрам',
        context: { tr: '___ çay içerim.', ru: 'По утрам я пью чай.' },
        slots: [
          { answer: 'sabah', options: [], label: '', why: '' },
          { answer: 'ları', options: ['ları', 'larda', 'leri'], label: '"по ..." (регулярно)', why: '"по утрам" - не падеж: sabahları, а не sabahlarda' },
        ],
        answer: 'sabahları',
        d: 2,
      },
      {
        kind: 'affix',
        base: 'gece',
        baseRu: 'ночь',
        task: 'по ночам',
        context: { tr: '___ kediler bahçede gezer.', ru: 'По ночам кошки гуляют по саду.' },
        slots: [
          { answer: 'gece', options: [], label: '', why: '' },
          { answer: 'leri', options: ['leri', 'ları', 'lerde'], label: '"по ..." (регулярно)', why: 'последняя гласная e, поэтому -leri' },
        ],
        answer: 'geceleri',
        d: 2,
      },
      {
        kind: 'transform',
        source: 'По вечерам я гуляю в парке.',
        instruction: 'Скажите это по-турецки',
        answer: 'Akşamları parkta yürürüm.',
        variants: ['Akşamları parkta yürüyorum.', 'Akşamları parkta yürüyüş yaparım.'],
        breakdown: [
          { text: 'akşam', label: '', why: '' },
          { text: 'ları', label: '"по ..." (регулярно)', why: 'привычка - -ları и широкое время' },
        ],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Сегодня утром я выпил чаю.',
        instruction: 'Скажите это по-турецки',
        answer: 'Bu sabah çay içtim.',
        variants: [],
        breakdown: [{ text: 'Bu sabah', label: 'один раз', why: 'сегодня утром - один раз: bu sabah, а не sabahları' }],
        blankWhole: true,
        d: 3,
      },
      {
        kind: 'transform',
        source: 'Этот суп кисловатый.',
        instruction: 'Скажите это по-турецки',
        answer: 'Bu çorba ekşimsi.',
        variants: [],
        breakdown: [
          { text: 'ekşi', label: '', why: '' },
          { text: 'msi', label: '"-оватый"', why: '-msı работает и со вкусом' },
        ],
        blankWhole: true,
        d: 3,
      },
    ],
  },

]
